import React from 'react';

export default () => <img src="/transparent-logo.png" width={167} alt="logo" />;
